import { getAsidePanelInitialState } from '../constants';
import { IApplicationState } from '../../../../../../types/types';
import { IAsidePanelState } from '../types';

export const getAsidePanel = (
    state: IApplicationState
): IAsidePanelState => {
    return state.asidePanel || getAsidePanelInitialState();
};
